<template>

<section class="premium-section contact-section">

<h2 class="section-title">Community & Contact</h2>

<p class="contact-description">

The Mudra community continues to grow through writers, creators, and supporters.
Follow the official channels below to stay updated with announcements and platform updates.

</p>


<div class="contact-links">

<a href="https://mudra-token.web.app" target="_blank" class="contact-link">
🌐 Website
</a>

<a href="mailto:mudratoken25@gmail.com" class="contact-link">
✉️ Email
</a>

<a href="https://x.com/Mudra_token" target="_blank" class="contact-link">
🐦 X
</a>

<a href="https://t.me/+BczKd5Qi_ikyOTk1" target="_blank" class="contact-link">
📢 Telegram
</a>

<a href="https://whatsapp.com/channel/0029VbB4MMtEquiLJhto0z40" target="_blank" class="contact-link">
🟢 WhatsApp
</a>

</div>


<p class="contact-footer">

Mudra aims to build a transparent creator ecosystem. Community feedback and participation help shape the future of the platform.

</p>

</section>

</template>



<style scoped>

.contact-section{
text-align:center;
}


/* Description */

.contact-description{

max-width:650px;
margin:auto;
margin-bottom:25px;
color:#d8faff;

}


/* LINKS ROW */

.contact-links{

display:flex;
justify-content:center;
gap:12px;
flex-wrap:wrap;

}


/* SMALL BOX */

.contact-link{

color:#00eaff;

font-weight:600;

font-size:14px;

text-decoration:none;

border:1px solid rgba(0,234,255,0.35);

padding:6px 12px;

border-radius:6px;

transition:0.2s;

}


/* Hover */

.contact-link:hover{

background:rgba(0,234,255,0.12);

transform:translateY(-1px);

}


/* Footer */

.contact-footer{

margin-top:25px;

font-size:14px;

color:#ccefff;

}


/* Mobile */

@media (max-width:600px){

.contact-links{

gap:8px;

}

.contact-link{

font-size:13px;
padding:5px 10px;

}

}

</style>